import React, { useEffect, useState } from "react";
import { Api } from "../../api";
import axios from "axios";
import { Headers } from "../../api/actions";
import Loading from "../../components/loading/loading";
import { useParams } from "react-router";

import NavbarLeft from "../../components/navbar/navbar_left";
import NavbarTop from "../../components/navbar/navbar_top";
import CoursesContent from "./component/courses-content";
import axiosInstance from "../../api/axios_instance";

const Courses = () => {
  const { page, search, active } = useParams();
  const pageCount = +page.slice(page.indexOf(":") + 1, page.length);
  const searchKeyword = search.slice(search.indexOf(":") + 1, search.length);
  const activeCourse = active.slice(active.indexOf(":") + 1, active.length);
  const [perpage, setPerpage] = useState(0);
  const [data, setData] = useState([]);
  const [PageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetData(
      setData,
      setLoading,
      pageCount,
      searchKeyword,
      activeCourse,
      setPerpage,
      PageSize
    );
  }, [pageCount, searchKeyword, PageSize, activeCourse]);
  const ObJectArrayData = [
    {
      id: 2,
      href: `/courses/page:${1}/search:${""}/active:`,
      title: "الدورات",
    },
  ];
  if (!loading) {
    return (
      <section className="main">
        <NavbarLeft />
        <div className="main-body">
          <NavbarTop ArrayData={ObJectArrayData} />
          <div className="main-body__content">
            <Loading />
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="main">
      <NavbarLeft />
      <div className="main-body">
        <NavbarTop ArrayData={ObJectArrayData} />
        <div className="main-body__content">
          <CoursesContent
            ArrayData={data}
            perpage={perpage}
            pagenumber={pageCount}
            setLoading={setLoading}
            PageSize={PageSize}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </section>
  );
};

export default Courses;

const GetData = async (
  setData,
  setLoading,
  pageCount,
  searchKeyword,
  activeCourse,
  setPerpage,
  PageSize
) => {
  var data = {
    pageNumber: pageCount,
    searchKeyword: searchKeyword,
    pageSize: PageSize,
  };
  if (activeCourse)
    data.isActive =
      activeCourse === "true" ? true : activeCourse === "false" ? false : "";

  const options = {
    method: "post",
    url: `${Api}ClassRoom/SearchForClassRooms`,
    headers: Headers,
    data,
  };
  await axiosInstance(options)
    .then(function (response) {
      setData(response.data.responseObject.items);
      setLoading(true);

      setPerpage(
        Math.ceil(
          response.data.responseObject.totalItemsCount /
            response.data.responseObject.pageSize
        )
      );
    })
    .catch(function (error) {
      setLoading(true);
    });
};
